// extracted by mini-css-extract-plugin
export default {"blockwrapper":"ES","header":"FS","name":"GS","columns":"HS","imagewrapper":"IS","addinfo":"JS","description":"KS","price":"LS","old":"MS","new":"NS","desc_d":"OS","infoblock":"PS","desc_m":"QS"};
    if(module.hot) {
      // 1715632478716
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  